import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <div className="header">
           <a href="#" className="back-link" onClick={handleBackClick}>&#8592; BACK</a>
        </div>
    );
};

export default BackButton;
